"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/web.timers.js");

var _alert = _interopRequireDefault(require("element-ui/lib/alert"));

var _dom = require("element-ui/lib/utils/dom");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "el-notification-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    "class": ['el-notification', {
      'is-alert': _vm.alert
    }, _vm.customClass, _vm.horizontalClass],
    style: _vm._px2rem(_vm.positionStyle, 24, ['top', 'bottom']),
    attrs: {
      "id": _vm.id,
      "role": "alert",
      "conversionForbiddenPx2Rem": "top,bottom"
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.clearTimer();
      },
      "mouseleave": function mouseleave($event) {
        _vm.startTimer();
      },
      "click": _vm.click
    }
  }, [(_vm.type || _vm.iconClass) && !_vm.alert ? _c('i', {
    staticClass: "el-notification__icon",
    "class": [_vm.typeClass, _vm.iconClass],
    attrs: {}
  }) : _vm._e(), _vm._v(" "), !_vm.alert ? _c('div', {
    staticClass: "el-notification__group",
    "class": {
      'is-with-icon': _vm.typeClass || _vm.iconClass
    },
    attrs: {}
  }, [_c('h2', {
    staticClass: "el-notification__title",
    attrs: {},
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.message,
      expression: "message"
    }],
    staticClass: "el-notification__content",
    attrs: {}
  }, [_vm._t("default", [typeof _vm.message === 'string' ? [!_vm.dangerouslyUseHTMLString ? _c('div', [_vm._v(_vm._s(_vm.message))]) : _c('div', {
    attrs: {},
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })] : _vm.message instanceof Array ? _vm._l(_vm.message, function (msg, i) {
    return _c('div', {
      key: i,
      attrs: {}
    }, [_vm._v(_vm._s(msg))]);
  }) : _vm._e()], {})], 2), _vm._v(" "), _vm.showClose ? _c('div', {
    staticClass: "el-notification__closeBtn el-icon-close",
    attrs: {},
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.close($event);
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.alert ? _c('el-alert', {
    attrs: {
      "title": _vm.message,
      "dangerouslyUseHTMLString": _vm.dangerouslyUseHTMLString,
      "controlled": true,
      "type": _vm.type,
      "closable": _vm.showClose,
      "show-icon": "",
      "has-scrollbar": _vm.scrollbar,
      "max-height": _vm.alertMaxHeight
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  data: function data() {
    return {
      visible: false,
      title: '',
      message: '',
      duration: 4500,
      type: '',
      showClose: true,
      customClass: '',
      iconClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      timer: null,
      dangerouslyUseHTMLString: false,
      position: 'top-right',
      // 扩展 允许消息框重叠
      overlapable: false,
      // 扩展支持alert 风格
      alert: false,
      // 扩展scrollbar
      scrollbar: false,
      maxHeight: 0,
      maxHeightOffset: 0,
      availableHeight: 0,
      container: Object,
      debounceResize: null,
      openKeyAll: false,
      id: null
    };
  },
  components: (0, _defineProperty2["default"])({}, _alert["default"].name, _alert["default"]),
  computed: {
    typeClass: function typeClass() {
      return this.type && typeMap[this.type] ? "el-icon-".concat(typeMap[this.type]) : '';
    },
    horizontalClass: function horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },
    verticalProperty: function verticalProperty() {
      return /^top-/.test(this.position) ? 'top' : 'bottom';
    },
    positionStyle: function positionStyle() {
      return (0, _defineProperty2["default"])({}, this.verticalProperty, "".concat(this.verticalOffset, "px"));
    },

    /** 扩展scrollbar */
    alertMaxHeight: function alertMaxHeight() {
      if (this.scrollbar) {
        return this.maxHeight ? this.maxHeight : this.availableHeight - this.verticalOffset - this.maxHeightOffset;
      } else {
        return 'unset';
      }
    }
  },
  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    },
    duration: function duration() {
      this.startTimer();
    }
  },
  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    click: function click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },
    close: function close() {
      this.closed = true;

      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (!this.openKeyAll) {
        return;
      }

      if (e.keyCode === 46 || e.keyCode === 8) {
        this.clearTimer(); // detele 取消倒计时
      } else if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      } else {
        this.startTimer(); // 恢复倒计时
      }
    },

    /** 扩展scrollbar */
    updateAvailableHeight: function updateAvailableHeight(container) {
      if (container && container.clientHeight) {
        this.availableHeight = container.clientHeight;
      } else {
        this.availableHeight = document.documentElement.clientHeight;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        if (!_this2.closed) {
          _this2.close();
        }
      }, this.duration);
    }

    document.addEventListener('keydown', this.keydown);
    /** 扩展scrollbar */

    this.$nextTick(function () {
      _this2.updateAvailableHeight();

      _this2.debounceResize = (0, _debounce["default"])(200, function () {
        return _this2.updateAvailableHeight();
      });
      (0, _dom.on)(window, 'resize', _this2.debounceResize);
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
    /** 扩展scrollbar */

    (0, _dom.off)(window, 'resize', this.debounceResize);
  }
};
exports["default"] = _default;